import CreateAccount from '@/pages/CreateAccount'

export default {
    path: '',
    component: CreateAccount,
    children: [
        {
            path: '/create/account/:ref',
            name: 'Create Account',
            component: CreateAccount,
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/createaccount.js